
<h1 mat-dialog-title>
    Personalised Analytics View - Save As
  </h1>
<div mat-dialog-content >
  <form [formGroup]="formGroup">
  <p class="col-md-12" >
    You can save a reference to the selected analytics view either by 
    saving a bookmark to the view itself or by saving the filter states.
  </p>
  <div class="col-md-6">
    <div class="col-md-12"  >
      
        <mat-label class="form-label">Enter a view name</mat-label>
                  
        <input 
        formControlName="viewName"
        [class.is-invalid]="
                  formGroup.controls['viewName'].invalid &&
                  formGroup.controls['viewName'].touched
              "
        class="form-control col-md-12" 
        matInput 
        placeholder="View name" 
        [maxLength]="200" [minLength]="1">
        <div *ngIf="
            (formGroup.controls['viewName'].invalid &&
              formGroup.controls['viewName'].touched) ||
              formGroup.controls['viewName'].dirty">
          <small *ngIf="formGroup.controls['viewName'].errors?.['required']" class="text-danger fs-13">View name is required</small>
          <small *ngIf="formGroup.controls['viewName'].errors?.['pattern']" class="text-danger fs-13">Please provide a valid view  name</small>
          
          <small *ngIf="formGroup.controls['viewName'].errors?.['maxLength']" class="text-danger fs-13">View name should be &lt; 200 characters</small>
        </div>
    </div>

    <div class="col-md-12"  >
      <mat-label class="form-label">Reference Type</mat-label><br/>
      <mat-radio-group  formControlName="snapshotType" value="Snapshot">
        <mat-radio-button  value="Snapshot">Bookmark</mat-radio-button>
        <mat-radio-button  value="Filters">Filters</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
 
  <div class="col-md-12 alert alert-warning" style="font-size: smaller;margin-top: 1em;" >
    <mat-icon style="vertical-align: text-bottom;"  >warning</mat-icon>
    Please note that a bookmark may be incompatible with future versions of the toolkit 
    as it is enhanced to give you deeper insights.
  </div>
</form>
</div>
<div mat-dialog-actions style="text-align: right;">
  <em style="float: left;">The data is never saved in your personalised view.</em>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button class="theme-btn" [disabled]="formGroup.invalid" (click)="processForm()" >Apply</button>
</div>
